import httpService from './httpService'
import SessionService from './sessionService'

async function purchase(organizationId, nonce, paymentPackage, subscribe) {
  const data = {
    payment_method_nonce: nonce,
    payment_package: paymentPackage,
    subscribe: subscribe
  }
  return httpService.apiRequest('post', `/payment/purchase/${SessionService.getUserUsername()}/organization/${organizationId}`, data)
}

async function purchaseOfficeConnect(officeId, nonce, paymentPackage, subscribe) {
  const data = {
    payment_method_nonce: nonce,
    payment_package: paymentPackage,
    subscribe: subscribe
  }
  return httpService.apiRequest('post', `/payment/purchase/${SessionService.getUserUsername()}/office/${officeId}`, data)
}

async function purchaseExtraMinutes(organizationId, nonce, paymentPackage) {
  const data = {
    payment_method_nonce: nonce,
    payment_package: paymentPackage
  }
  return httpService.apiRequest('post', `/payment/purchase/${SessionService.getUserUsername()}/extraMinutes/${organizationId}`, data)
}

async function purchaseGlobalAccess(serialNo, nonce, paymentPackage, subscribe) {
  const data = {
    payment_method_nonce: nonce,
    payment_package: paymentPackage,
    subscribe: subscribe
  }
  return httpService.apiRequest('post', `/payment/purchase/${SessionService.getUserUsername()}/device/${serialNo}`, data)
}

async function cancelPurchase(subscriptionId, organization, office) {
  const data = {}
  if (organization) {
    data.organizationId = organization._id
  } else if (office) {
    data.officeId = office._id
    data.office = office
  }
  return httpService.apiRequest('post', `/payment/purchase/${SessionService.getUserUsername()}/cancel/${subscriptionId}`, data)
}

async function getRatePlans() {
  return httpService.apiRequest('get', `/payment/purchase/plans`)
}
async function generateToken() {
  return httpService.apiRequest('get', `/payment/client_token`)
}
export default {
  purchase,
  purchaseOfficeConnect,
  purchaseExtraMinutes,
  purchaseGlobalAccess,
  cancelPurchase,
  getRatePlans,
  generateToken
}



// WEBPACK FOOTER //
// ./src/services/paymentService.js